import { PaginatorResult } from '~/api';
import { buildModule, createFiltersModule, createPaginationModule, defineSingleFilter } from '../utils';

export default buildModule()
	.withSubmodules({
		filters: createFiltersModule({
			filters: {
				action: defineSingleFilter('action', String),
				start: defineSingleFilter('start', String),
				end: defineSingleFilter('end', String),
				roleId: defineSingleFilter('roleId', Number),
			},
		}),
		list: buildModule()
			.withSubmodules({
				pagination: createPaginationModule({
					itemCountGetter: 'eventLog/totalCount',
				}),
			}),
	})
	.withState({
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	});
